<template>
	<div>
		<img v-if="base64" :src="base64" style="max-width: 100%;" />
		<j-spinner class="p8" v-else size="small" />
	</div>
</template>

<script>
import axios from "axios"
import JSpinner from "@/components/JSpinner"

export default {
	props: {
		filekey: String
	},

	components: {
		JSpinner
	},

	data() {
		return {
			base64: null
		}
	},

	methods: {
		async getImgPreview() {
			// Auth
			const headers = {
				Authorization: `Bearer ${window.TK}`
			}
			const res = await axios({
				url:
					"https://api.asia.covergo.com/api/v1/files/" +
					encodeURIComponent(this.filekey),
				headers,
				responseType: "arraybuffer"
			})
			// Convert to base64 URL
			if (res?.data) {
				const b64encoded = Buffer.from(res.data).toString("base64")
				const mimetype = "image/png;image/jpeg;image/bmp;image/gif"
				this.base64 = "data:" + mimetype + ";base64," + b64encoded
			}
		}
	},

	created() {
		this.getImgPreview()
	}
}
</script>
